// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add this to your CSS file */
div::-webkit-scrollbar {
    height: 6px;
   
}

div::-webkit-scrollbar-thumb {
    background-color: #D9D9D9;
  
    border-radius: 30px;
    /* Rounded corners */
}

div::-webkit-scrollbar-thumb:hover {
    background-color: #D9D9D9;
    /* Color on hover */
}

.MuiCardContent-root css-46bh2p-MuiCardContent-root{
    padding: 0px; /* Adjusted padding */
}

.select-dropdown {
    width: 250px; /* Set your desired fixed width */
    min-width: 250px; /* Ensure it doesn't shrink */
}`, "",{"version":3,"sources":["webpack://./src/components/view-errors-and-fixes/discrepanciesSummary/descrepencies.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,WAAW;;AAEf;;AAEA;IACI,yBAAyB;;IAEzB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,YAAY,EAAE,qBAAqB;AACvC;;AAEA;IACI,YAAY,EAAE,iCAAiC;IAC/C,gBAAgB,EAAE,6BAA6B;AACnD","sourcesContent":["/* Add this to your CSS file */\ndiv::-webkit-scrollbar {\n    height: 6px;\n   \n}\n\ndiv::-webkit-scrollbar-thumb {\n    background-color: #D9D9D9;\n  \n    border-radius: 30px;\n    /* Rounded corners */\n}\n\ndiv::-webkit-scrollbar-thumb:hover {\n    background-color: #D9D9D9;\n    /* Color on hover */\n}\n\n.MuiCardContent-root css-46bh2p-MuiCardContent-root{\n    padding: 0px; /* Adjusted padding */\n}\n\n.select-dropdown {\n    width: 250px; /* Set your desired fixed width */\n    min-width: 250px; /* Ensure it doesn't shrink */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
